import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';

const useEkycTransitionScreenCheck = (): boolean => {
  const siteId = useSelector(select.cms.getSiteId);
  const isRetryScreenEnabled = useFeature(FeatureFlag.SwcRetryScreen);

  const allowedSites = [Sites.FRA, Sites.DE];
  return isRetryScreenEnabled && allowedSites.includes(siteId);
};

export default useEkycTransitionScreenCheck;
